import { get, post } from '@/utils/request'

const memberApi = {
  /* 个人管理_个人资料信息 */
  getMemberInfo: function () {
    return get('system/member/profile/profile', {})
  },
  /* 个人管理_修改密码 */
  updatePass: function (params) {
    return post('system/member/profile/modify-pwd', {
      oldPwd: params.oldPwd,
      newPwd: params.newPwd
    })
  }
}

export default memberApi



// WEBPACK FOOTER //
// ./src/api/member.js